export enum AiCreationUploadErrorType {
  GENERIC = 'generic',
  PAGE_COUNT_UNAVAILABLE = 'page-count-unavailable',
  PAGE_LIMIT = 'page-limit',
}

interface UploadErrorPayload {
  status?: number;
  data?: {
    error_type?: string;
    errors?: Record<string, unknown>;
  };
}

const PAGE_COUNT_UNAVAILABLE_ERROR_TYPE = 'page_count_unavailable';

export const getAiCreationUploadErrorType = (
  payload?: UploadErrorPayload,
): AiCreationUploadErrorType => {
  const data = payload?.data;
  const errors = data?.errors;

  if (
    payload?.status === 503
    || data?.error_type === PAGE_COUNT_UNAVAILABLE_ERROR_TYPE
    || errors?.page_count_unavailable
  ) {
    return AiCreationUploadErrorType.PAGE_COUNT_UNAVAILABLE;
  }

  if (errors?.page_count) {
    return AiCreationUploadErrorType.PAGE_LIMIT;
  }

  return AiCreationUploadErrorType.GENERIC;
};
